import GenericRequest, { METHOD_GET } from '../../../../shared/webservices/GenericRequest';

export class WorkDetailTask extends GenericRequest {

    _request; // WorkDetailRequest

    constructor(request) {
        super(METHOD_GET, request.route());
    }

    overrideRequest() {}

}



// WEBPACK FOOTER //
// ./src/app/my-contractors/work/detail/work-detail/WorkDetailTask.js